export default "__VITE_ASSET__Od1H52qx__"